import { FC, useState } from 'react';
import styled from './index.module.scss';
import EfLink from '@elem/ui/ef-link';
import { Checkbox, CheckboxProps, Modal } from 'antd-v5';
import type { IProductItem } from './config';

// de专属弹窗
interface IPorps {
    item: null | IProductItem;
    show: boolean;
    close: () => void;
}
const DutyFreeModal: FC<IPorps> = ({ item, show, close }) => {
    const [checked, setChecked] = useState(true);
    const handleChange: CheckboxProps['onChange'] = (e) => {
        setChecked(e.target.checked);
    };
    const handleSubmit = () => {
        if (!checked) return;
        close();
        item && window.open(item.link, '_blank');
    };
    if (!show) return <></>;
    return (
        <Modal className={styled.DutyFreeModal} onCancel={close} open={show} footer={false}>
            <p className="title">Die Voraussetzungen für 0 % MwSt. Lieferung</p>
            <div className="content">
                Sehr geehrter Kunde,
                <br />
                <br />
                es ist möglich, dass für die ausgewählten Produkte Nullsteuersatz gemäß § 12 Abs. 3 dUStG für Deutschland oder § 28 Abs. 62 öUStG für Österreich
                gilt. Bitte prüfen Sie, ob die Voraussetzungen in Ihrem Fall erfüllt sind. Der Verkäufer leistet keine Steuerberatung und übernimmt keine Gewähr
                für das Eintreten steuerrechtlicher Tatbestände. Klicken Sie{' '}
                <EfLink href="https://www.gesetze-im-internet.de/ustg_1980/__12.html" target="_blank">
                    hier
                </EfLink>{' '}
                um den Gesetzestext des § 12 Abs. 3 UStG in Deutschland und{' '}
                <EfLink href="https://www.oesterreich.gv.at/themen/umwelt_und_klima/energie_und_ressourcen_sparen/1/Seite.2430320.html" target="_blank">
                    hier
                </EfLink>{' '}
                um nähere Informationen zu den Voraussetzungen des § 28 Abs. 62 UStG in Österreich zu lesen.
                <br />
                <br />
                1. Bitte prüfen Sie für die nach Deutschland verkaufte(n) Ware(n), ob die Voraussetzungen für die Umsatzsteuerbefreiung nach § 12 Abs. 3 UStG
                erfüllt sind. Ist dies der Fall, kreuzen Sie bitte an, dass Sie beim Kauf der Ware von der Umsatzsteuer befreit sind. Mit dem Ankreuzen dieses
                Feldes versichern Sie, dass
                <br />
                <br />
                - die Liefer- und Rechnungsadresse in Deutschland liegt,
                <br />
                <br />
                - das erworbene Produkt auf oder in der Nähe von Privatwohnungen, Wohnungen, öffentlichen und anderen Gebäuden, die für Tätigkeiten im
                öffentlichen Interesse genutzt werden, oder auf Wohnwagen oder Wohnschiffen, die nicht oder nur gelegentlich bewegt werden, installiert wird,
                und
                <br />
                <br />
                - die installierte Bruttoleistung der Photovoltaikanlage laut Marktstammdatenregister nicht mehr als 30 Kilowatt (peak) nicht übersteigt oder
                nicht übersteigen wird.
                <br />
                <br />
                Die Anwendung des Nullsteuersatzes ist nicht mit einem verbindlichen Preisangebot des Verkäufers verbunden. Der Gesamtpreis ergibt sich aus den
                Produktpreisen und Steuern sowie ggf. zusätzlichen Kosten wie Versand etc. Wenn der Kunde angibt, dass ein Steuersatz von 0% anwendbar ist, wird
                der angegebene Preis auf dieser Grundlage angezeigt.
                <br />
                <br />
                - die Liefer- und Rechnungsadresse in Österreich liegt,
                <br />
                <br />
                - das erworbene Produkt auf oder an Gebäuden installiert wird, die Wohnzwecken dienen, von Körperschaften des öffentlichen Rechts oder von
                privaten Körperschaften, Personenvereinigungen und Vermögensmassen, die gemeinnützigen, mildtätigen oder kirchlichen Zwecken dienen, genutzt
                werden, und
                <br />
                <br />
                - die installierte Bruttoleistung der Photovoltaikanlage 35 Kilowatt (Peak) nicht übersteigt oder nicht übersteigen wird.
                <br />
                <br />
                Die Anwendung des Nullsteuersatzes ist nicht mit einem verbindlichen Preisangebot des Verkäufers verbunden. Der Gesamtpreis ergibt sich aus den
                Produktpreisen und Steuern sowie ggf. zusätzlichen Kosten wie Versand etc. Wenn der Kunde angibt, dass ein Steuersatz von 0% anwendbar ist, wird
                der angegebene Preis auf dieser Grundlage angezeigt.
            </div>
            <div className="choose">
                <Checkbox checked={checked} onChange={handleChange}>
                    Hiermit bestätigen Sie, das Sie die Voraussetzungen für eine umsatzsteuerfreie Lieferung gemäß § 12 Abs. 3 von Deutschland erfüllen.
                </Checkbox>
                {!checked && (
                    <p className="error">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M7 12.25C9.8995 12.25 12.25 9.8995 12.25 7C12.25 4.10051 9.8995 1.75 7 1.75C4.10051 1.75 1.75 4.10051 1.75 7C1.75 9.8995 4.10051 12.25 7 12.25Z"
                                stroke="#F8200C"
                                strokeWidth="0.875"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path d="M7 8.16683V4.0835" stroke="#F8200C" strokeWidth="0.875" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M7 9.9165H7.00583" stroke="#F8200C" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        * Bestätigen Sie bitte die Information oben
                    </p>
                )}
            </div>
            <EfLink className="btn" onClick={handleSubmit}>
                Bestätigen
            </EfLink>
        </Modal>
    );
};

export default DutyFreeModal;
